<ng-container *ngIf="accountHook">
  <!-- Header -->
  <div class="header">
    <!-- Toolbar -->
    <div class="toolbar">
      <div class="info">
        <!-- Subject -->
        <div class="subject">{{ accountHook.object_type }} : {{ accountHook.hook_name }}</div>
      </div>

      <div class="mr-4"></div>
    </div>
  </div>

  <!-- Threads -->
  <div class="threads">
    <!-- Thread -->
    <div class="thread">
      <form [formGroup]="accountHookForm">
        <div class="row description">
          <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
            <textarea
              [disabled]="isActionsDisabled"
              matInput
              treoAutogrow
              [formControlName]="'hook_code'"
              [spellcheck]="false"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="reply-form-buttons mt-3 flex flex-auto ml-2">
          <!-- Actions -->
          <div class="flex flex-auto justify-start">
            <mat-form-field>
              <mat-label>Processing Model</mat-label>
              <mat-select [disabled]="isActionsDisabled" [formControlName]="'processing_mode'">
                <mat-option [value]="'background'"> Background </mat-option>
                <mat-option [value]="'realtime'"> Realtime </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-auto justify-start">
            <mat-form-field>
              <mat-label>Order</mat-label>
              <input matInput [formControlName]="'rank'" />
            </mat-form-field>
          </div>
          <div *ngIf="accountHookForm.get('rank').errors?.pattern">Please enter a valid integer</div>
          <div *ngIf="!isActionsDisabled" class="flex flex-auto justify-start ml-2 mt-7">
            <mat-checkbox [color]="'primary'" [formControlName]="'active'"> Enabled </mat-checkbox>
          </div>
          <div class="flex flex-auto justify-end mt-7">
            <button [disabled]="isActionsDisabled" mat-flat-button type="button" (click)="delete()">Delete</button>
            <button
              [disabled]="isActionsDisabled"
              mat-flat-button
              [color]="'primary'"
              type="submit"
              class="mr-5"
              (click)="save()"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
